<template>
  <div class>

      <CCard>
        <CCardHeader class="grey-header">
            <CRow class="flex-flow-column">
              <CCol>
                <strong
                  >{{
                    isUpdate
                      ? $t("cHotelRoomDet.updateTitle")
                      : $t("cHotelRoomDet.titleHeader")
                  }}
                </strong>
              </CCol>

              <p class="desc">{{ $t("cHotelRoomDet.descTxt") }}</p>
            </CRow>
          </CCardHeader>
                    <!-- <cPopupLoader v-if="isLoading"/> temp fix - removed popup loader if it is page-->

          <CCardBody>

        
        <ValidationObserver v-if="hotelRoomInfoObj" v-slot="{ handleSubmit }">
          <!-- <CForm
            v-if="hotelRoomInfoObj"
            @submit.prevent="handleSubmit(onRoomFormSubmit)"
          > -->
            <CRow></CRow>

            <div>
              <strong>
                <span> 
                 {{  $t('cHotelRoomDet.roomInfo')}}
                </span> 
              </strong>
            </div>
            <CRow v-if="isUpdate">
              <CCol>
                <cTextInputComponent
                  :label="$t('cHotelRoomDet.typeId')"
                  :placeholder="$t('cHotelRoomDet.typeId')"
                  v-model="hotelRoomInfoObj.roomid"
                  :isDisable="true"
                >
                </cTextInputComponent>
              </CCol>
              <CCol>
                <CContainer>
                  <div class="row">
                    <div
                      v-for="(mls, lindex) in hotelRoomInfoObj.hotelRoomsMls"
                      :key="lindex + 'ml'"
                      @click="toggleLanguageModal(mls)"
                      :class="mls!='en'?'col languagegrid':''"
                    >
                      <span v-if="mls!='en'" >{{getLangName(mls)}}</span>
                    </div>
                    <div
                      class="col languagegrid"
                      @click="toggleLanguageModal(false)"
                    >
                      Add Language
                    </div>
                  </div>
                </CContainer>
              </CCol>
            </CRow>

            <CRow v-if="isUpdate">
              <label>
                {{$t('cHotelRoomDet.status')}}
              </label>
              <br>
             
              <cStatusButton   class="generate-ex-btn label-margin-unset"
                    :isConfirm="true"
                    :buttonDesc="$t('cHotelRoomDet.statusDesc')"
                    :defaultStatus.sync="hotelRoomInfoObj.isActive"
                    @change="onStatusChange"
                    :label="{checked: $t('cHotelRoomDet.active'), unchecked: $t('cHotelRoomDet.inactive')}" >

              </cStatusButton>
            </CRow>
            <CRow>
              <cTextInputComponent
                rules="required|noInitialSpace|max:150"
                v-model="hotelRoomInfoObj.roomname"
                :label="$t('cHotelRoomDet.roomName')"
                :placeholder="$t('cHotelRoomDet.namePh')"
              ></cTextInputComponent>
            </CRow>

            <CRow>
              <CCol>
                <label>{{ $t("cHotelRoomDet.roomType") }}</label>

                <div class="input-group">
                  <ValidationProvider
                    :rules="'required'"
                    :vid="'1'"
                    v-slot="{ errors }"
                  >
                    <multiselect
                      :multiple="false"
                      :allow-empty="false"
                      :placeholder="$t('cHotelRoomDet.typePh')"
                      v-model="hotelRoomInfoObj.roomtypes"
                      :options="lsRoomTypes"
                      deselectLabel
                      deselectGroupLabel
                      selectLabel
                      selectedLabel
                    >
                    <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                    </multiselect>

                    <div
                      v-if="errors && errors[0]"
                      class="invalid-feedback icon"
                    >
                      <div>
                        <span>{{ errors[0] }}</span>
                      </div>
                    </div>
                  </ValidationProvider>
                </div>
              </CCol>
            </CRow>

            <CRow>
              <CCol>
                <label>{{ $t("cHotelRoomDet.view") }}</label>

                <div class="input-group">
                  <multiselect
                    :multiple="true"
                    :allow-empty="true"
                    :placeholder="$t('cHotelRoomDet.viewPh')"
                    v-model="hotelRoomInfoObj.roomview"
                    :options="lsViews"
                    track-by="code"
                    label="name"
                    deselectLabel
                    deselectGroupLabel
                    selectLabel
                    selectedLabel
                  ><span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                  </multiselect>
                </div>
              </CCol>
            </CRow>
               <CRow>
              <cTextInputComponent
                v-model="hotelRoomInfoObj.noOfRooms"
                :label="$t('cHotelRoomDet.rooms')"
                  rules="required|noInitialSpace|onlyNumber|max:15"
                :placeholder="$t('cHotelRoomDet.totRooms')"
              ></cTextInputComponent>
            </CRow>
                 <CRow>
              <cTextInputComponent
                v-model="hotelRoomInfoObj.roomsizeSqft"
                rules="noInitialSpace|onlynumber|max:15"
                :label="$t('cHotelRoomDet.roomSize')"
                :placeholder="$t('cHotelRoomDet.roomSizePh')"
              ></cTextInputComponent>
               <span class="d-flex">
                      <!-- class="d-flex" -->
                     <cHelpTip
                        :content="$t('cHotelRoomDet.sizeTooltip')"
                      ></cHelpTip>
                    </span>
            </CRow>
               <div>
              <strong>
                <!-- <span> 
                 {{  $t('cHotelRoomDet.desc')}}
                </span>  -->
              </strong>
            </div>
            <CRow>
              <cTextInputComponent
                v-model="hotelRoomInfoObj.roomdesc"
                rules="required|noInitialSpace|max:300"
                :label="$t('cHotelRoomDet.desc')"
                :placeholder="$t('cHotelRoomDet.desc')"
              ></cTextInputComponent>

              <!-- <label>{{$t('cHotelRoomDet.desc')}}</label>
                <br />
                <CCardBody>
                <div v-html="hotelRoomInfoObj.desc"></div>
                </CCardBody> -->
            </CRow>
              <div>
              <strong>
                <span> 
                 {{  $t('cHotelRoomDet.guestDetails')}}
                </span> 
              </strong>
            </div>
            <CRow>
              <cTextInputComponent
                v-model="hotelRoomInfoObj.maxGuests"
                :label="$t('cHotelRoomDet.maxOcc')"
                :placeholder="$t('cHotelRoomDet.maxOccPh')"
                :rules="'required|noInitialSpace|onlyNumber|max:3'"
              ></cTextInputComponent>
              <span class="d-flex">
                      <!-- class="d-flex" -->
                     <cHelpTip
                        :content="$t('cHotelRoomDet.maxOccTooltip')"
                      ></cHelpTip>
                    </span>
            </CRow>
            <CRow>
              <cTextInputComponent
                v-model="hotelRoomInfoObj.maxAdults"
                :label="$t('cHotelRoomDet.maxAdt')"
                :name='"hotelRoom"'
                :placeholder="$t('cHotelRoomDet.maxAdtPh')"
                :rules="'required|noInitialSpace|onlyNumber|max:3|max_value:'+ getMaxOccupancy(hotelRoomInfoObj.maxGuests,  hotelRoomInfoObj.maxChild)"
              ></cTextInputComponent>
              <span class="d-flex">
                      <!-- class="d-flex" -->
                     <cHelpTip
                        :content="$t('cHotelRoomDet.maxAdtTooltip')"
                      ></cHelpTip>
                    </span>
            </CRow>
            <CRow>
              <cTextInputComponent
                v-model="hotelRoomInfoObj.maxChild"
     
                :label="$t('cHotelRoomDet.maxChild')"
                  :name='"hotelRoom"'
                :placeholder="$t('cHotelRoomDet.maxChildPh')"
                :rules="'required|noInitialSpace|onlyNumber|max:3|max_value:'+ getMaxOccupancy(hotelRoomInfoObj.maxGuests,  hotelRoomInfoObj.maxAdults)"
              ></cTextInputComponent>
               <span class="d-flex">
                      <!-- class="d-flex" -->
                     <cHelpTip
                        :content="$t('cHotelRoomDet.maxChdTooltip')"
                      ></cHelpTip>
                    </span>
            </CRow>

            <CRow>
              <cTextInputComponent
                v-model="hotelRoomInfoObj.maxExtraBed"
                :label="$t('cHotelRoomDet.maxExtraBed')"
                :placeholder="$t('cHotelRoomDet.maxExtraBedPH')"
                :rules="'required|noInitialSpace|onlyNumber|max:3'"
              ></cTextInputComponent>
               <span class="d-flex">
                      <!-- class="d-flex" -->
                     <cHelpTip
                        :content="$t('cHotelRoomDet.maxExtraBedTooltip')"
                      ></cHelpTip>
                    </span>
            </CRow>
         
       

            

            <!-- <CRow>
          <cTextInputComponent
            :label="$t('cHotelRoomDet.lang')"
            :placeholder="$t('cHotelRoomDet.langPh')"
          >
          </cTextInputComponent>
            </CRow>-->
            <CRow>
              <CCol
                
              >
                <cRoomImages ref="roomimage"
                @isImageUpdated="getRoomImageStatus"
                @isMainImageUploaded="isMainUploaded"
                  :roomid="hotelRoomInfoObj.roomid"
                  :showEdit="false"
                ></cRoomImages>
              </CCol>
            </CRow>

            <CRow>
              <CCol>
                <cRoomAmenities
                  @onSelect="onAmenitiesSelect"
                  :selAmenities="
                    isUpdate ? hotelRoomInfoObj.amenitiesIds : null
                  "
                ></cRoomAmenities>
              </CCol>
            </CRow>

            <CRow>
              <CCol>
                <cBedTypes
                  @onSelect="onBedTypesSelect"
                  :selBedTypes="isUpdate ? hotelRoomInfoObj.bedtypeid : null"
                ></cBedTypes>
              </CCol>
            </CRow>
            <CRow>
              <CCol> </CCol>
            </CRow>

            <CCardFooter class="d-flex justify-content-end">
              <CAlert v-if="alertValue" color="warning" closeButton>
                {{ alertValue }}
              </CAlert>

              <div class="main-cta-btn">
                <CButton
                  color="danger"
                  class="action-c-btn"
                  @click="onRoomFormCancel()"
                >
                  <img src="@imgPath/img/svg/icons/close.svg" />
                  {{ $t("cHotelRoomDet.cancel") }}</CButton
                >
                 <!-- <CButton v-if="showBtn"
                  type="submit"
                  v-c-tooltip.hover="isImageSaved==false?
                { content:'Please save the image',active:false }:
                ''"
                  @click.prevent="isImageSaved?handleSubmit(onRoomFormSubmit):null"
                  color="success removewrap"
                  class="action-c-btn"
                > -->
                <CButton v-if="showBtn"
                  type="submit"
                 
                  @click.prevent.once="handleSubmit(onRoomFormSubmit)"
                  color="success removewrap"
                  class="action-c-btn"
                >
                  <img src="@imgPath/img/svg/icons/correct.svg" />
                  {{
                    isUpdate
                      ? $t("cHotelRoomDet.updateRoom")
                      : $t("cHotelRoomDet.createRoom")
                  }}</CButton
                >
              </div>
            </CCardFooter>
          <!-- </CForm> -->
        </ValidationObserver>
          </CCardBody>
        <CModal
          size="xl"
          v-if="showLangForm"
          title="Add Language"
          :close-on-backdrop="false"
          centered
          :show.sync="showLangForm"
          fade
        >
          <template #footer>
            <div class=""></div>
          </template>

          <template #header>
            <div class="">
              <label>Add Language</label>
            </div>
          </template>
          <ValidationObserver ref="obs" v-slot="{ handleSubmit }">
            <CForm @submit.prevent="handleSubmit(updateRoomMl)">
   
                <div v-if="hotelLangRes" class="subtitile-details">
                  <CCol class="d-flex">
                    <p class="v-center field-wrapper required-field">
                      <label>{{ "Language code" }}</label>
                    </p>
                  </CCol>

                  <div class="col">
                    <ValidationProvider
                      :rules="'required'"
                      :vid="'1'"
                      v-slot="{ errors }"
                    >
                      <multiselect
                        :multiple="false"
                        :allow-empty="false"
                        :placeholder="'Select the language code'"
                        v-model="roomLang.lang"
                        :options="hotelLangRes.allLanguage"
                        track-by="langcode"
                        label="langName"
                        deselectLabel
                        deselectGroupLabel
                        selectLabel
                        selectedLabel
                        v-on:input="onLanguageChange"
                        ><span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                      </multiselect>

                      <div
                        v-if="errors && errors[0]"
                        class="invalid-feedback icon"
                      >
                        <div>
                          <span>{{ errors[0] }}</span>
                        </div>
                      </div>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="subtitile-details">
                  <CCol class="d-flex">
                    <p class="v-center field-wrapper required-field">
                      <label>{{ "Room Name" }}</label>
                    </p>
                  </CCol>

                  <div class="col">
                    <cTextInputComponent
                      v-model="roomLang.roomName"
                      :placeholder="'Room Name'"
                      class="w-100"
                      :rules="'required|noInitialSpace'"
                      :maxLength="150"
                    ></cTextInputComponent>
                  </div>
                </div>

                <div class="subtitile-details">
                  <!-- <CCol class="d-flex">
                    <p class="v-center field-wrapper required-field">
                      <label>{{ $t("createHotel.description") }}</label>
                    </p>
                  </CCol> -->

                  <div class="col-12">
                    <label>{{ $t("createHotel.description") }}</label>
                    <ValidationProvider
                      v-slot="{ errors }"
                      :rules="'required'"
                    >
                      <!-- <quillEditor
                        v-model="roomLang.desc"
                        :options="editorOption"
                        @change="onDesEditorChange($event)"
                      ></quillEditor> -->
                           <cRichTextEditor v-model="roomLang.desc" :selValue="roomLang.desc" @getEditorText="onDesEditorChange"/> 

                      <div
                        v-if="errors && errors[0]"
                        class="invalid-feedback icon"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                      <div
                        v-else-if="alert.description"
                        class="invalid-feedback icon"
                      >
                        <span>{{ alert.description }}</span>
                      </div>
                    </ValidationProvider>
                  </div>
                </div>
              

              <CCardFooter class="d-flex justify-content-end">
                <div class="main-cta-btn">
                  <CButton
                    @click="toggleLanguageModal"
                    color="danger"
                    class="action-c-btn"
                  >
                    <img src="@imgPath/img/svg/icons/close.svg" />
                    {{ "Cancel" }}</CButton
                  >
                 
                  <CButton
                    col="12"
                    type="submit"
                    color="success removewrap"
                    class="action-c-btn"
                  >
                    <img src="@imgPath/img/svg/icons/correct.svg" />
                    {{hotelRoomInfoObj && roomLang.lang &&
                     hotelRoomInfoObj.hotelRoomsMls.includes(roomLang.lang.langcode)
                    ?"Update":"Create" }}</CButton
                  >
                </div>
              </CCardFooter>
            </CForm>
          </ValidationObserver>
        </CModal>
      </CCard >

    <cAlertModal
      v-if="showAlertModal"
      :key="'sys'"
      :buttonList="getModalButtons()"
      :status="2"
      :isShowIcon="true"
      :show="showAlertModal"
      :desc="$t('hotelInfo.desc')"
    >
    </cAlertModal>
  </div>
</template>

<script>
import {
  COMPONENT_NAME,
  PATHNAME,
  DEFAULT_DROPDOWN_STATUS,
} from "../../../../util/constants";
import router, { goBack, navigate } from "../../../../router/index";

import { mapGetters, mapActions } from "vuex";
import Logger from "../../../../services/logger";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage,
} from "../../../../util/apiValidate";
import {
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody,
  OrderByList,
  cloneData,
  groupBy,
  cloneDeep,
  showSuccessToast,
} from "../../../../util/util";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES,
} from "../../../../config/API_DATA";
import BaseConfiguration from "../../../../config/base";
import apiCreateHotelRoom from "../../../../services/apiCreateHotelRoom";
import apiUpdateHotelRoom from "../../../../services/apiUpdateHotelRoom";
import apiGetRoomTypes from "../../../../services/apiGetRoomTypes";
import apiGetBedTypes from "../../../../services/apiGetBedTypes";
import apiGetAllHotelAmenities from "../../../../services/apiGetAllHotelAmenities";
import apiGetHotelRooms from "../../../../services/apiGetHotelRooms";

import apiGetRatePlan from "../../../../services/apiGetRatePlan";
import apiGetHotelCancelPolicy from "../../../../services/apiGetHotelCancelPolicy";
import cTextInputComponent from "../../../../components/form/cTextInputComponent";
import cContentEdit from "../../../../components/hms/manage/hotelInfo/cContentEdit";
import cRoomAmenities from "../../../../components/hms/manage/hotelInfo/cRoomAmenities";
import cBedTypes from "../../../../components/hms/manage/hotelInfo/cBedTypes";
import cRoomLang from "../../../../components/hms/manage/hotelInfo/cRoomLang";
import cHelpTip from "../../../../components/cHelpTip";
import cRoomImages from "../../../../components/hms/manage/hotelInfo/cRoomImages";
import cTable from "../../../../components/dataTable/cTable.vue";
import cAlertModal from "../../../../components/form/cAlertModal";
import cRichTextEditor from "../../../../components/form/cRichTextEditor";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import multiselect from "vue-multiselect";

import cRoomRatePlans from "../../../../components/hms/manage/hotelInfo/cRoomRatePlans";

// import "quill/dist/quill.core.css";
// import "quill/dist/quill.snow.css";
// import "quill/dist/quill.bubble.css";
// import { quillEditor } from "vue-quill-editor";
import { i18n } from "../../../../plugins/i18n";
import apiGetRoomMl from "../../../../services/apiGetRoomMl";
import apiUpdateRoomMl from "../../../../services/apiUpdateRoomMl";
import apiGetHotelRoomInfo from "../../../../services/apiGetHotelRoomInfo";
import cStatusButton from './../../../form/cStatusButton'
import cPopupLoader from "../../../../components/cPopupLoader";

export default {
  name: COMPONENT_NAME.C_HOTEL_ROOM_NEW,

  components: {
     cHelpTip,
    cContentEdit,
    cAlertModal,
    cStatusButton,
    cTextInputComponent,
    multiselect,
    ValidationProvider,
    cRoomRatePlans,
    ValidationObserver,
    cRoomAmenities,
    cTable,
    cBedTypes,
    cRoomLang,
    cRichTextEditor,
    // quillEditor,
    cRoomImages,
    cPopupLoader
  },

  props: {
    showEdit: {
      type: Boolean,
      default: false,
    },
  },

  data: () => {
    return {
      isMainImageUpload:false,
      showBtn:true,
      alertValue: null,
      isUpdate: false,

      lsRoomTypes: [],

      showAlertModal: false,

      lsViews: [],

      showLangForm: false,
      alert: {
        description: null,
      },
      editorOption: {
        placeholder: i18n.tc("createHotel.descriptionPl"),
        theme: "snow",
      },
      hotelLangRes: null,
      roomLang: {
        lang: null,
        roomName: null,
        desc: null,
      },
      updatedRoomMlRes: null,
      hotelRoomInfoObj: null,
      isImageSaved: false,
      isLoading:true,
      //  ratePlan:null
    };
  },

  computed: {
    ...mapGetters("sHotelInfo", {
      hotelObj: "GET_HOTEL_OBJ",
      GET_RATE_PLAN: "GET_RATE_PLAN",
      GET_HOTEL_LANG: "GET_HOTEL_LANG",
      SEL_HOTEL_ROOM_OBJ: "GET_SEL_HOTEL_ROOM_OBJ",
    }),
    ...mapGetters("shmsManage", {
      GET_ALL_ENUMS: "GET_ALL_ENUMS",
    }),
  },

  methods: {
    ...mapActions("sHotelInfo", {
      SET_HOTEL_ROOM_OBJ: "SET_HOTEL_ROOM_OBJ",
    }),
    ...mapActions("sHotelInfo", {
      SET_CANCEL_POLICY: "SET_CANCEL_POLICY",
      SET_RATE_PLAN: "SET_RATE_PLAN",
    }),
    ...mapActions("sRatePlan", { SET_SEL_RATE_PLAN: "SET_SEL_RATE_PLAN" }),
    showAlert(val) {
      this.alertValue = val;
    },
    




    getMaxOccupancy(pAvailable,pOccupied) {
         let retValue=0;
    
        try {
          if(BaseConfiguration.isDebug) console.log("getMaxOccupancy");
          pAvailable=!isNaN( parseInt(pAvailable))? parseInt(pAvailable) :0
          pOccupied =!isNaN( parseInt(pOccupied))? parseInt(pOccupied):0
          


          if(pAvailable>0 && pOccupied>=0 &&  pAvailable>=pOccupied)
           {
              retValue = pAvailable-pOccupied
          }

          else if( (pAvailable==pOccupied) )
          {
             retValue= pAvailable
          }
          else if( pAvailable>0 )
          {
            retValue =pAvailable
          }


       
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.C_HOTEL_ROOM_NEW,
                  "error in getMaxOccupancy",
                  err.toString(),
                  "getMaxOccupancy",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 

    onStatusChange(pStatus) {
        try {
          if(BaseConfiguration.isDebug) console.log("onStatusChange");

     this.hotelRoomInfoObj.isActive=pStatus
        
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.C_HOTEL_ROOM_NEW,
                  "error in onStatusChange",
                  err.toString(),
                  "onStatusChange",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
    },

       getLangName(pLangCode) {
       let retValue=null;
       let langname;
        try {
          if(BaseConfiguration.isDebug) console.log("getLangName");
          if(this.hotelLangRes){
          retValue = this.hotelLangRes.allLanguage.filter(lanObj => {
            if (lanObj.langcode == pLangCode) {
              return lanObj.langName
             
            }
          })
          }
          if(retValue && retValue[0] && retValue[0].langName){
            langname = retValue[0].langName
          }
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.C_HOTEL_ROOM_NEW,
                  "error in getLangName",
                  err.toString(),
                  "getLangName",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return langname;
  },

  isMainUploaded(pIsMainImage){
    this.isMainImageUpload = pIsMainImage;
  },

    getRoomImageStatus(pIsImageSaved) {
        try {
          if(BaseConfiguration.isDebug) console.log("getRoomImageStatus");
          this.isImageSaved = pIsImageSaved
    //  if(this.isImageSaved){
        this.$emit("onRoomFormSubmit");
        //  }
        } catch (err) {
                let body = Logger.buildRequest(
                 FILE_NAME.C_HOTEL_ROOM_NEW,
                  "error in getRoomImageStatus",
                  err.toString(),
                  "getRoomImageStatus",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        
        }, 

    async onRoomFormSubmit() {
      try {
        if (BaseConfiguration.isDebug) console.log("onRoomFormSubmit");
        let createdRes;
        let updatedRes;
        let successMsg;
        if (this.isUpdate) {
          updatedRes = await this.updateHotelRoom();

          if(updatedRes && updatedRes.isUpdated)
          {
            successMsg='The Room'+this.hotelRoomInfoObj.roomname+' was updated Successfully'
            this.$refs.roomimage.updateHotelRoomImage(this.hotelRoomInfoObj.roomid)
             showSuccessToast(successMsg)
          }
        } else {
          createdRes = await this.createHotelRoom();

          if(createdRes && createdRes.roomid)
          {
            successMsg ='The Room'+this.hotelRoomInfoObj.roomname+' was created Successfully'
            this.$refs.roomimage.updateHotelRoomImage(createdRes.roomid)
             showSuccessToast(successMsg)
          }
        }
     if(!this.isMainImageUpload){
       this.$emit("onRoomFormSubmit");
     }
      
     /*    if (!BaseConfiguration.manageHotelPopup) {
          goBack();
        } */
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_ROOM_NEW,
          "error in onRoomFormSubmit",
          err.toString(),
          "onRoomFormSubmit",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onRoomFormCancel() {
      try {
        if (BaseConfiguration.isDebug) console.log("onRoomFormCancel");

        this.$emit("onRoomFormCancel");
        this.toggleAlertModal();

   /*      if (!BaseConfiguration.manageHotelPopup) {
          goBack();
        } */
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_ROOM_NEW,
          "error in onRoomFormCancel",
          err.toString(),
          "onRoomFormCancel",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async toggleLanguageModal(pLangcode) {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleLanguageModal");
        if (this.hotelLangRes && pLangcode != "en") {
          for (
            let index = 0;
            index < this.hotelLangRes.allLanguage.length;
            index++
          ) {
            if (pLangcode == this.hotelLangRes.allLanguage[index].langcode) {
              this.roomLang.lang = this.hotelLangRes.allLanguage[index];
              break;
            }
          }
        }
        let txtalert = this.alert
        for(var i in txtalert){
          if(txtalert[i]){
            txtalert[i]=null;
          }
        }
        this.showLangForm = !this.showLangForm;
        if (this.showLangForm) {
          this.hotelLangRes.allLanguage = this.hotelLangRes.allLanguage.filter(
            (lang) => lang.langcode != "en"
          );
          if (pLangcode != false && pLangcode != "en") {
            this.updatedRoomMlRes = await this.getRoomMl(
              this.hotelRoomInfoObj,
              this.roomLang.lang
            );
            if (this.updatedRoomMlRes) {
              this.roomLang.roomName = this.updatedRoomMlRes.roomname;
              this.roomLang.desc = this.updatedRoomMlRes.roomdesc;
            }
          } else if (pLangcode == false) {
            this.roomLang.lang = null;
            this.roomLang.roomName = this.hotelRoomInfoObj.roomname;
            this.roomLang.desc = this.hotelRoomInfoObj.roomdesc;
          }
        }
        if (!this.showLangForm) {
          // this.hotelRoomInfoObj = await this.getHotelRoomlInfo();
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_ROOM_NEW,
          "error in toggleLanguageModal",
          err.toString(),
          "toggleLanguageModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onDesEditorChange(pEditorText,pAlertValue) {
      try {
        if (BaseConfiguration.isDebug) console.log("onDesEditorChange");
           this.roomLang.desc=pEditorText;
           this.alert.description=pAlertValue;
       
  
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_ROOM_NEW,
          "error in onDesEditorChange",
          err.toString(),
          "onDesEditorChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async onLanguageChange(pLang) {
      try {
        if (BaseConfiguration.isDebug) console.log("onLanguageChange");

        this.updatedRoomMlRes = await this.getRoomMl(
          this.hotelRoomInfoObj,
          pLang
        );
        if (this.updatedRoomMlRes) {
          this.roomLang.roomName = this.updatedRoomMlRes.roomname;
          this.roomLang.desc = this.updatedRoomMlRes.roomdesc;
          this.$refs.obs.reset();
        }

      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_ROOM_NEW,
          "error in onLanguageChange",
          err.toString(),
          "onLanguageChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    isValidTextValues(pAlert) {
        let retValue=true;
        try {
          if(BaseConfiguration.isDebug) console.log("isValidTextValues");
        for(let i=0;i<Object.keys(pAlert).length;i++){
          if(pAlert[Object.keys(pAlert)[i]]){
            retValue=false;
            break;
          }else{
            retValue=true;
          }
        }
         
    
        } catch (err) {
                let body = Logger.buildRequest(
                   FILE_NAME.C_HOTEL_ROOM_NEW,
                  "error in isValidTextValues",
                  err.toString(),
                  "isValidTextValues",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 

    async updateRoomMl() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("updateRoomMl");
        var isValid = this.isValidTextValues(this.alert)
        if (this.hotelObj && this.hotelRoomInfoObj && isValid) {
          let updateMlRequest = apiUpdateRoomMl.buildRequest(
            this.hotelObj.hotelid,
            this.hotelRoomInfoObj.roomid,
            this.roomLang
          );

          if (updateMlRequest) {
            let updateMlResponse = await apiUpdateRoomMl.getResponse(
              updateMlRequest
            );

            if (VALIDATE_SUCCESS_RES(updateMlResponse)) {
              this.alertValue = null;
              retValue = updateMlResponse.data.data;

              await this.onHotelRoomEdit(cloneDeep(this.SEL_HOTEL_ROOM_OBJ));
              this.showLangForm = !this.showLangForm;
            } else {
              let error = getErrorMessage(updateMlResponse);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                this.alertValue = getErrorAlertValue(error);
              }
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_ROOM_NEW,
          "error in updateRoomMl",
          err.toString(),
          "updateRoomMl",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    async getHotelRoomlInfo(pHotelInfoObj) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getHotelRoomlInfo");
        if (this.hotelObj && pHotelInfoObj) {
          let hotelroomInfoRequest = apiGetHotelRoomInfo.buildRequest(
            this.hotelObj.hotelid,
            pHotelInfoObj.roomid
          );

          if (hotelroomInfoRequest) {
            let hotelroomInfoResponse = await apiGetHotelRoomInfo.getResponse(
              hotelroomInfoRequest
            );

            if (VALIDATE_SUCCESS_RES(hotelroomInfoResponse)) {
              this.alertValue = null;
              retValue = hotelroomInfoResponse.data.data.roomInfo;
            } else {
              let error = getErrorMessage(hotelroomInfoResponse);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                this.alertValue = getErrorAlertValue(error);
              }
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_ROOM_NEW,
          "error in getHotelRoomlInfo",
          err.toString(),
          "getHotelRoomlInfo",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async getRoomMl(pRoomObj, pLang) {
      let retValue = [];
      try {
        let roomid =
          pRoomObj && pRoomObj.roomId ? pRoomObj.roomId : pRoomObj.roomid;
        if (BaseConfiguration.isDebug) console.log("getRoomMl");
        if (this.hotelObj) {
          let RoomMlRequest = apiGetRoomMl.buildRequest(
            this.hotelObj.hotelid,
            roomid,
            pLang.langcode
          );

          if (RoomMlRequest) {
            let RoomMlResponse = await apiGetRoomMl.getResponse(RoomMlRequest);

            if (VALIDATE_SUCCESS_RES(RoomMlResponse)) {
              this.alertValue = null;
              retValue = RoomMlResponse.data.data;
            } else {
              let error = getErrorMessage(RoomMlResponse);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                this.alertValue = getErrorAlertValue(error);
              }
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_ROOM_NEW,
          "error in getRoomMl",
          err.toString(),
          "getRoomMl",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

  

    getModalButtons() {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getModalButtons");
        retValue = [
          {
            name: this.$t("hotelInfo.leave"),
            func: this.onRoomFormCancel,
          },

          {
            name: this.$t("hotelInfo.stay"),
            func: this.toggleAlertModal,
          },
        ];
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_ROOM_NEW,
          "error in getModalButtons",
          err.toString(),
          "getModalButtons",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    toggleAlertModal() {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleAlertModal");

       // this.showAlertModal = !this.showAlertModal;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_ROOM_NEW,
          "error in toggleAlertModal",
          err.toString(),
          "toggleAlertModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async onHotelRoomEdit(pHotelRoomObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("onHotelRoomEdit");
        //
        //  this.toggleEditMode();
        this.isUpdate = true;
        this.showAlert(null);
        pHotelRoomObj = cloneDeep(pHotelRoomObj);

        let hotelRoomInfo = await this.getHotelRoomlInfo(pHotelRoomObj);
        if (hotelRoomInfo) {
             
                   hotelRoomInfo. maxAdults =                    hotelRoomInfo. maxAdults +''

                     
                  hotelRoomInfo.  maxChild =                  hotelRoomInfo.  maxChild +''

                 hotelRoomInfo.     noOfRooms =                 hotelRoomInfo.     noOfRooms+''

                 hotelRoomInfo.     maxGuests =                 hotelRoomInfo.     maxGuests+''



            hotelRoomInfo.isActive=hotelRoomInfo.isactive
          hotelRoomInfo.maxExtraBed = hotelRoomInfo.maxExtrabed+'';
          hotelRoomInfo.roomtypes = hotelRoomInfo.roomtypes.roomtypename;
          hotelRoomInfo.roomview = (hotelRoomInfo.roomview &&hotelRoomInfo.roomview.length  &&hotelRoomInfo.roomview[0])
            ? this.lsViews.filter((view) =>
                hotelRoomInfo.roomview[0].includes(view.code)
              )
            : [];
          this.hotelRoomInfoObj = cloneDeep(hotelRoomInfo);
        } else {
          throw "invalid hotel info";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_ROOM_NEW,
          "error in onHotelRoomEdit",
          err.toString(),
          "onHotelRoomEdit",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onAddRoom() {
      try {
        if (BaseConfiguration.isDebug) console.log("onAddRoom");
        //  this.addNew = !this.addNew;

        //    this.toggleEditMode();
        this.isUpdate = false;
        this.showAlert(null);

        this.hotelRoomInfoObj = {
          hotelId: this.hotelObj.hotelid,
          roomname: "",
          roomtypes: "",
          roomview: [],
          roomOffer: "",
          maxGuests: "",
          maxAdults: "",
          maxChild: "",
          maxExtraBed: "",
          noOfRooms: "",
          roomsizeSqft: "",
          roomdesc: "",
          langcode: [],
          amenitiesIds: [],
          bedtypeid: [],
        };
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_ROOM_NEW,
          "error in onAddRoom",
          err.toString(),
          "onAddRoom",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onBedTypesSelect(pSelTypes) {
      try {
        if (BaseConfiguration.isDebug) console.log("onBedTypesSelect");

        if (pSelTypes && pSelTypes.length) {
          this.hotelRoomInfoObj.bedtypeid = pSelTypes.map(
            (val) => val.bedtypeid
          );
        } else {
          this.hotelRoomInfoObj.bedtypeid = [];
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_ROOM_NEW,
          "error in onBedTypesSelect",
          err.toString(),
          "onBedTypesSelect",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onAmenitiesSelect(pSelAmenities) {
      try {
        if (BaseConfiguration.isDebug) console.log("onAmenitiesSelect");

        if (pSelAmenities && pSelAmenities.length) {
          this.hotelRoomInfoObj.amenitiesIds = pSelAmenities.map(
            (val) => val.amenitiesId
          );
        } else {
          this.hotelRoomInfoObj.amenitiesIds = [];
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_ROOM_NEW,
          "error in onAmenitiesSelect",
          err.toString(),
          "onAmenitiesSelect",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async getRoomTypes() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getRoomTypes");

        
          let roomTypesReq = apiGetRoomTypes.buildRequest(
          
          );

          if (roomTypesReq) {
            // this.SET_AGENCY_REQ(getRoutesRequest); //save req in store
            let roomTypesRes = await apiGetRoomTypes.getResponse(roomTypesReq);

            if (VALIDATE_SUCCESS_RES(roomTypesRes)) {
              this.showAlert(null);
              retValue = roomTypesRes.data.data;
             
            } else {
              let error = getErrorMessage(roomTypesRes);
              //  this.showAlert(error);
              let isJwt = handleJWT(error);
              if (!isJwt) {
                getErrorAlertValue(error);
              }
            }
          }
            else
          {
            throw 'invalid req'
          }
        
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_ROOM_NEW,
          "error in getRoomTypes",
          err.toString(),
          "getRoomTypes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    toCreateRoomReq(pRoomObj, isUpdate) {
      let retValue = {
        hotelId: this.hotelObj.hotelid,
        roomName: "",
        roomType: "",
        view: [],
        roomOffer: "",
        maxOccupancy: "",
        maxAdult: "",
        maxChild: "",
        maxExtraBed: "",
        noOfRoom: "",
        roomSize: "",
        description: "",
        languages: [],
        amenities: [],
        bedTypes: [],
      };
      try {
        if (BaseConfiguration.isDebug) console.log("toCreateRoomReq");
        retValue.roomName = pRoomObj.roomname;
        retValue.roomType = pRoomObj.roomtypes;
        for (let i = 0; i < pRoomObj.roomview.length; i++) {
          retValue.view.push(pRoomObj.roomview[i].code);
        }
        retValue.roomOffer = pRoomObj.roomOffer?pRoomObj.roomOffer:"";
        retValue.maxOccupancy = Number(pRoomObj.maxGuests);
        retValue.maxAdult = Number(pRoomObj.maxAdults);
        retValue.maxChild = Number(pRoomObj.maxChild);
        retValue.maxExtraBed = Number(pRoomObj.maxExtraBed);
        retValue.noOfRoom = Number(pRoomObj.noOfRooms);
        retValue.roomSize = Number(pRoomObj.roomsizeSqft);
        retValue.description = pRoomObj.roomdesc;
        retValue.languages = pRoomObj.langcode;
        retValue.amenities = pRoomObj.amenitiesIds;
        retValue.bedTypes = pRoomObj.bedtypeid;
        retValue.isActive =pRoomObj.isActive

        if (isUpdate) {
          // retValue.isActive = true;
          retValue.roomId = pRoomObj.roomid;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_ROOM_NEW,
          "error in toCreateRoomReq",
          err.toString(),
          "toCreateRoomReq",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async createHotelRoom() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("createHotelRoom");
        let reqBody = this.toCreateRoomReq(cloneDeep(this.hotelRoomInfoObj));
        if (reqBody) {
          let createHotelRoomReq = apiCreateHotelRoom.buildRequest(reqBody);

          if (createHotelRoomReq) {
            // this.SET_AGENCY_REQ(getRoutesRequest); //save req in store
            let createHotelRoomRes = await apiCreateHotelRoom.getResponse(
              createHotelRoomReq
            );

            if (VALIDATE_SUCCESS_RES(createHotelRoomRes)) {
              this.showAlert("Created Successfully");
              //  await this.initRoomTableData();
              //    this.toggleEditMode();

              retValue = createHotelRoomRes.data.data;
               
             
            } else {
              let error = getErrorMessage(createHotelRoomRes);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                this.showAlert(getErrorAlertValue(error));
              }
            }
          }
        } else {
          throw "invalid hotel room obj";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_ROOM_NEW,
          "error in createHotelRoom",
          err.toString(),
          "createHotelRoom",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async updateHotelRoom() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("updateHotelRoom");

        if (this.hotelRoomInfoObj) {
          let updateHotelRoomReq = apiUpdateHotelRoom.buildRequest(
            this.toCreateRoomReq(cloneDeep(this.hotelRoomInfoObj), true)
          );

          if (updateHotelRoomReq) {
            // this.SET_AGENCY_REQ(getRoutesRequest); //save req in store
            let updateHotelRoomRes = await apiUpdateHotelRoom.getResponse(
              updateHotelRoomReq
            );

            if (VALIDATE_SUCCESS_RES(updateHotelRoomRes)) {
              // this.showAlert("Updated Successfully");
              //   this.toggleEditMode();
              retValue = updateHotelRoomRes.data.data;
             
            } else {
              let error = getErrorMessage(updateHotelRoomRes);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                this.showAlert(getErrorAlertValue(error));
              }
            }
          }
        } else {
          throw "invalid hotel room obj";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_ROOM_NEW,
          "error in updateHotelRoom",
          err.toString(),
          "updateHotelRoom",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async initData() {
      try {
        if (BaseConfiguration.isDebug) console.log("initData");
        ///initialize hotel room obj

        let roomTypesRes = await this.getRoomTypes();
        if (roomTypesRes && roomTypesRes.list) {
          this.lsRoomTypes = roomTypesRes.list;
        }
        if (this.GET_ALL_ENUMS) {
          var obj = {
            name: null,
            code: null,
          };
          Object.keys(this.GET_ALL_ENUMS.hotelRoomView).forEach((key) => {
            obj.name = this.GET_ALL_ENUMS.hotelRoomView[key];
            obj.code = key;
            this.lsViews.push(cloneData(obj));
          });
        }

        if (this.SEL_HOTEL_ROOM_OBJ) {
          await this.onHotelRoomEdit(cloneDeep(this.SEL_HOTEL_ROOM_OBJ));
        } else {
          this.onAddRoom();
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_ROOM_NEW,
          "error in initData",
          err.toString(),
          "initData",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
  },

  async created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");

      //   this.editMode = this.showEdit;
      await this.initData();

      //  await this.initRoomTableData();

      // this.tableFields=this.getTableFields()
      if (this.GET_HOTEL_LANG) {
        this.hotelLangRes = this.GET_HOTEL_LANG;
      } else {
        this.hotelLangRes = await this.getHotelLang();
      }
      this.isLoading=false;
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.C_HOTEL_ROOM_NEW,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
};
</script>
